import logo from "../logo.svg";
import React, { Component } from "react";
import moment, { unix } from "moment";
import Footer from "../components/Footer";
import {
  Clock,
  Briefcase,
  Users,
  DollarSign,
  Hash,
  Check,
  Slash,
  Wind,
  Anchor,
  Twitter,
  Image,
  Globe,
  Flag,
  Maximize2,
  FileText,
} from "react-feather";
import { Helmet } from "react-helmet";
import Header from "../components/Header";
import { Link } from "react-router-dom";

export default class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      errormsg: "",
      spacexdata: [],
      companydata: [],
      launches_next: [],
      launches_upcoming: [],
      countdown: "",
    };
  }

  fetchData = () => {
    fetch("https://api.spacexdata.com/v3/launches/latest")
      .then((response) => {
        if (response.status !== 200) {
          if (response.status == 429) {
            this.setState({
              isLoading: true,
              errormsg:
                "We're currently experiencing high loads. Please try refreshing.",
            });
          } else {
            this.setState({
              isLoading: true,
              errormsg:
                "We couldn't fetch the data. Status code: " + response.status,
            });
          }
          return;
        }

        // Examine the text in the response
        response.json().then((data) => {
          this.setState({ spacexdata: data, isLoading: false, errormsg: "" });
        });
      })
      .catch(function (err) {
        console.log("Fetch Error :-S", err);
      });

    fetch("https://api.spacexdata.com/v3/launches/upcoming")
      .then((response) => {
        if (response.status !== 200) {
          if (response.status == 429) {
            this.setState({
              isLoading: true,
              errormsg:
                "We're currently experiencing high loads. Please try refreshing.",
            });
          } else {
            this.setState({
              isLoading: true,
              errormsg:
                "We couldn't fetch the data. Status code: " + response.status,
            });
          }
          return;
        }

        // Examine the text in the response
        response.json().then((data) => {
          this.setState({
            launches_upcoming: data[1],
            isLoading: false,
            errormsg: "",
          });
        });
      })
      .catch(function (err) {
        console.log("Fetch Error :-S", err);
      });

    fetch("https://api.spacexdata.com/v3/info")
      .then((response) => {
        if (response.status !== 200) {
          if (response.status == 429) {
            this.setState({
              isLoading: true,
              errormsg:
                "We're currently experiencing high loads. Please try refreshing.",
            });
          } else {
            this.setState({
              isLoading: true,
              errormsg:
                "We couldn't fetch the data. Status code: " + response.status,
            });
          }
          return;
        }

        // Examine the text in the response
        response.json().then((data) => {
          this.setState({ companydata: data, isLoading: false, errormsg: "" });
        });
      })
      .catch(function (err) {
        console.log("Fetch Error :-S", err);
      });

    fetch("https://api.spacexdata.com/v3/launches/next")
      .then((response) => {
        if (response.status !== 200) {
          if (response.status == 429) {
            this.setState({
              isLoading: true,
              errormsg:
                "We're currently experiencing high loads. Please try refreshing.",
            });
          } else {
            this.setState({
              isLoading: true,
              errormsg:
                "We couldn't fetch the data. Status code: " + response.status,
            });
          }
          return;
        }

        // Examine the text in the response
        response.json().then((data) => {
          this.setState({
            launches_next: data,
            isLoading: false,
            errormsg: "",
          });
          this.startCount();
        });
      })
      .catch(function (err) {
        console.log("Fetch Error :-S", err);
      });
  };

  startCount = () => {
    const { launches_next } = this.state;
    if (!this.state.isLoading || launches_next.launch_date_unix !== undefined) {
      this.interval = setInterval(() => {
        var then = moment(launches_next.launch_date_utc);
        var now = moment();
        var c = moment(then - now);
        var duration = c.format("DD:HH:mm:ss");

        console.log("then: ", then);
        console.log("now: ", now);
        this.setState({ countdown: duration });
      }, 1000);
    }
  };

  componentDidMount = () => {
    this.setState({ isLoading: true });
    this.fetchData();
  };

  render() {
    const {
      spacexdata,
      companydata,
      launches_next,
      isLoading,
      errormsg,
      launches_upcoming,
      countdown,
    } = this.state;

    //test
    // console.log(spacexdata.links);
    if (isLoading || errormsg) {
      return (
        <>
          <Header />
          <section class="hero is-black is-fullheight">
            <div class="hero-body">
              <div class="container has-text-centered">
                {errormsg ? (
                  <>
                    <h1 className="title is-5 has-text-white">
                      SpaceX Tracker
                    </h1>
                    <p>{errormsg}</p>
                    <br />
                    <button
                      onClick={() => {
                        window.location.reload();
                      }}
                      className="button is-dark"
                      style={{ marginBottom: "25px" }}
                    >
                      Try again
                    </button>
                    <br />
                    <a href="https://www.twitter.com/ingusjan" target="_blank">
                      <Twitter size={18} />
                    </a>
                  </>
                ) : (
                  <p style={{ opacity: "0.2" }}>Loading</p>
                )}
              </div>
            </div>
          </section>
        </>
      );
    }

    return (
      <div>
        <Helmet>
          <title>SpaceX Tracker — Get the most up-to-date SpaceX Launch</title>
          <meta
            name="title"
            content="SpaceX Tracker — Get the most up-to-date SpaceX Launch"
          />
          <meta
            name="description"
            content={`With SpaceX Tracker you can get the most up-to-date data about the recent launch. The latest launch is currently ${spacexdata.mission_name}. SpaceX was founded in 2002 by Elon Musk.`}
          />

          <meta property="og:type" content="website" />
          <meta property="og:url" content="https://spacexnow.netlify.app" />
          <meta
            property="og:title"
            content="SpaceX Tracker — Get the most up-to-date SpaceX Launch"
          />
          <meta
            property="og:description"
            content={`With SpaceX Tracker you can get the most up-to-date data about the recent launch. The latest launch is currently ${spacexdata.mission_name}. SpaceX was founded in 2002 by Elon Musk.`}
          />
          <meta property="twitter:card" content="summary_large_image" />
          <meta
            property="twitter:url"
            content="https://spacexnow.netlify.app"
          />
          <meta
            property="twitter:title"
            content="SpaceX Tracker — Get the most up-to-date SpaceX Launch"
          />
          <meta
            property="twitter:description"
            content={`With SpaceX Tracker you can get the most up-to-date data about the recent launch. The latest launch is currently ${spacexdata.mission_name}. SpaceX was founded in 2002 by Elon Musk.`}
          />
        </Helmet>
        <Header />

        <div
          className="notification is-black is-bold is-radiusless"
          style={{
            borderBottom: "1px solid rgb(54, 54, 54)",
            paddingTop: "10px",
          }}
        >
          <p style={{ opacity: "0.3" }}>
            Before this: {spacexdata.mission_name} (
            {moment(spacexdata.launch_date_utc).fromNow()},{" "}
            {spacexdata.launch_success ? "Successful" : "Failed"})
          </p>
        </div>

        <div className="notification is-black is-bold is-radiusless">
          <p style={{ float: "right" }}>
            Next up: {moment(launches_upcoming.launch_date_utc).fromNow()}
            <br />
            <span style={{ opacity: "0.3" }}>
              Mission {launches_upcoming.mission_name}
            </span>
          </p>
          <img
            style={{ width: "120px", marginBottom: "15px" }}
            src={
              launches_next.links != undefined &&
              launches_next.links.mission_patch_small
            }
          />
          <h3 className="title is-3" id="missionTitle">
            {launches_next.mission_name}
            <span style={{ marginLeft: "15px" }}>
              <Link to="/countdown">
                <Maximize2
                  color="gray"
                  size={28}
                  style={{ verticalAlign: "middle", marginBottom: "5px" }}
                />
              </Link>
            </span>
          </h3>
          <h2 className="subtitle" style={{ opacity: "0.3" }}>
            Upcoming Launch
          </h2>{" "}
          <p
            style={{
              marginTop: "0px",
              color: launches_next.launch_success ? "#77e28f" : "#e2a477",
            }}
          >
            {launches_next.launch_success ? (
              <Check
                size={18}
                style={{
                  verticalAlign: "middle",
                  marginBottom: "3px",
                  marginRight: "5px",
                }}
              />
            ) : (
              <Flag
                size={18}
                style={{
                  verticalAlign: "middle",
                  marginBottom: "3px",
                  marginRight: "5px",
                }}
              />
            )}{" "}
            {launches_next.launch_success
              ? "Mission Successful"
              : "Mission Pending"}
          </p>
          <p style={{ marginTop: "0px" }}>
            <Clock
              size={18}
              style={{
                verticalAlign: "middle",
                marginBottom: "3px",
                marginRight: "5px",
              }}
            />{" "}
            Launching in {countdown} (
            {moment(launches_next.launch_date_utc).format("DD/MM/YYYY")})
          </p>
          <p
            style={{
              marginTop: "0px",
            }}
          >
            <Hash
              size={18}
              style={{
                verticalAlign: "middle",
                marginBottom: "3px",
                marginRight: "5px",
              }}
            />{" "}
            Flight number: {launches_next.flight_number}
          </p>
          <p
            style={{
              marginTop: "0px",
            }}
          >
            <Anchor
              size={18}
              style={{
                verticalAlign: "middle",
                marginBottom: "3px",
                marginRight: "5px",
              }}
            />{" "}
            {launches_next.rocket != undefined &&
              launches_next.rocket.rocket_name}
          </p>
          <br />
          <p>{launches_next.details}</p>
          <br />
          <a
            target="_blank"
            href={
              launches_next.links != undefined && launches_next.links.presskit
            }
          >
            <FileText
              size={18}
              style={{
                verticalAlign: "middle",
                marginBottom: "3px",
                marginRight: "5px",
              }}
            />
            View the {launches_next.mission_name} presskit
          </a>
        </div>

        <div className="notification is-dark is-radiusless">
          <h3
            className="subtitle is-4 has-text-centered"
            style={{ marginBottom: "40px" }}
          >
            Media from {spacexdata.mission_name}
          </h3>
          <div className="columns" style={{ marginTop: "15px" }}>
            {spacexdata.links == undefined ? (
              <p
                style={{
                  textAlign: "center",
                  margin: "0 auto",
                  marginBottom: "20px",
                  opacity: "0.3",
                }}
              >
                Media will be available at launch.
              </p>
            ) : (
              <>
                <div className="column has-text-centered">
                  <img
                    style={{ width: "auto", maxHeight: "290px" }}
                    src={
                      spacexdata.links != undefined &&
                      spacexdata.links.flickr_images[0]
                    }
                  />
                </div>

                <div className="column has-text-centered">
                  {spacexdata.links && spacexdata.links.youtube_id && (
                    <iframe
                      id="ytplayer"
                      type="text/html"
                      style={{ minWidth: "400px" }}
                      width="auto"
                      height="290"
                      src={`https://www.youtube.com/embed/${
                        spacexdata.links != undefined &&
                        spacexdata.links.youtube_id
                      }?autoplay=0&origin=https://spacexnow.netlify.app`}
                      frameborder="0"
                    ></iframe>
                  )}
                </div>
                <div className="column has-text-centered">
                  <img
                    style={{ width: "auto", maxHeight: "290px" }}
                    src={
                      spacexdata.links != undefined &&
                      spacexdata.links.mission_patch
                    }
                  />
                </div>
              </>
            )}
          </div>
        </div>

        <div className="notification is-black is-bold is-radiusless">
          <h2 className="subtitle is-4">About {companydata.name}</h2>
          <p>
            <Briefcase
              size={18}
              style={{
                verticalAlign: "middle",
                marginBottom: "3px",
                marginRight: "5px",
              }}
            />{" "}
            Founded: {companydata.founded} by {companydata.founder}
          </p>
          <p>
            <Users
              size={18}
              style={{
                verticalAlign: "middle",
                marginBottom: "3px",
                marginRight: "5px",
              }}
            />{" "}
            Employees:{" "}
            {companydata.employees != undefined &&
              companydata.employees
                .toString()
                .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
          </p>
          <p>
            <DollarSign
              size={18}
              style={{
                verticalAlign: "middle",
                marginBottom: "3px",
                marginRight: "5px",
              }}
            />{" "}
            Valuation: $
            {companydata.valuation != undefined &&
              companydata.valuation
                .toString()
                .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
          </p>
          <br />
          <p>{companydata.summary}</p>
          <br />
          <div style={{ display: "inline-flex" }}>
            <a
              href="https://twitter.com/SpaceX"
              target="_blank"
              style={{ marginRight: "10px" }}
            >
              <Twitter size={18} />
            </a>
            <a
              href="https://www.flickr.com/photos/spacex/"
              target="_blank"
              style={{ marginRight: "10px" }}
            >
              <Image size={18} />
            </a>
            <a href="https://www.spacex.com/" target="_blank">
              <Globe size={18} />
            </a>
          </div>
        </div>

        <Footer />
      </div>
    );
  }
}
